import { compose, filter, find, map } from 'lodash/fp';
import { Component, useEffect } from 'react';
import { createPortal } from 'react-dom';
// eslint-disable-next-line no-restricted-imports
import { Switch, matchPath, useHistory } from 'react-router';
import DelayUnmount, { useIsLeaving } from '../../react/components/DelayUnmount';
import useLocation from '../../react/hooks/useLocation';
import { BASE } from '../../routes';
import ErrorBoundary from '../ErrorBoundary';
import RouteError from '../RouteError';
import styles from './style.m.less';

const zenModeOpenBodyClassName = 'FullScreenRoute--open';
const timeout = 350;

const findMatch = find(({ match }) => !!match);

const zenRoot = document.getElementById('full-screen-root');
const mainWrapper = document.getElementsByClassName('main-wrapper')[0];

const ZenWrapper = ({ children }) => {
    const isLeaving = useIsLeaving();
    useEffect(() => {
        mainWrapper.setAttribute('aria-hidden', 'true');
        document.body.classList.add(zenModeOpenBodyClassName);
        return () => {
            mainWrapper.removeAttribute('aria-hidden');
            document.body.classList.remove(zenModeOpenBodyClassName);
        };
    }, []);
    return createPortal(
        <main role="main" className={isLeaving ? styles.zenWrapperHidden : styles.zenWrapper}>
            {children}
        </main>,
        zenRoot
    );
};

export default function RoutesWrapper({ zenRoutes = [], children }) {
    const location = useLocation();
    const history = useHistory();
    return (
        <RoutesWrapperInner location={location} zenRoutes={zenRoutes} action={history.action}>
            {children}
        </RoutesWrapperInner>
    );
}

class RoutesWrapperInner extends Component {
    state = {
        curPath: this.props.location.pathname + this.props.location.search,
        prevPath: undefined,
    };
    static getDerivedStateFromProps({ location: { pathname, search }, action }, { curPath, prevPath }) {
        const fullLocation = pathname + search;
        if (action === 'REPLACE') {
            return { prevPath, curPath: fullLocation };
        }
        return curPath !== fullLocation
            ? {
                  prevPath: curPath,
                  curPath: fullLocation,
              }
            : null;
    }

    render() {
        const { location, zenRoutes, children } = this.props;
        const { prevPath } = this.state;

        const zenRoute = compose(
            findMatch,
            map(([path, render]) => ({ render, match: matchPath(location.pathname, { path, exact: true }) })),
            filter(Boolean)
        )(zenRoutes);

        return (
            <>
                <DelayUnmount timeout={timeout}>
                    {zenRoute && (
                        <ZenWrapper>
                            <ErrorBoundary errorComponent={RouteError}>
                                {zenRoute.render({
                                    location,
                                    match: zenRoute.match,
                                    prevPath: prevPath && BASE + prevPath,
                                })}
                            </ErrorBoundary>
                        </ZenWrapper>
                    )}
                </DelayUnmount>
                <DelayUnmount timeout={timeout}>
                    {!zenRoute && <Switch location={location}>{children}</Switch>}
                </DelayUnmount>
            </>
        );
    }
}
